import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "sidebar" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "sidebar__top" }, [
  /*#__PURE__*/_createElementVNode("h2", null, "Dashboard")
], -1)
const _hoisted_3 = { class: "sidebar__menu" }
const _hoisted_4 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("ul", _hoisted_3, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.menu, (item) => {
        return (_openBlock(), _createElementBlock("li", {
          key: item?.to,
          class: "sidebar__menu-item"
        }, [
          (item.visible)
            ? (_openBlock(), _createBlock(_component_router_link, {
                key: 0,
                to: item.to
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(item.name) + " ", 1),
                  (item.children?.length)
                    ? (_openBlock(), _createElementBlock("span", {
                        key: 0,
                        class: _normalizeClass(["sidebar__menu-arrow material-icons", { 'active': item.menuOpen }]),
                        onClick: _withModifiers(($event: any) => (_ctx.toggleMenu(item)), ["prevent"])
                      }, " expand_more ", 10, _hoisted_4))
                    : _createCommentVNode("", true)
                ]),
                _: 2
              }, 1032, ["to"]))
            : _createCommentVNode("", true),
          (item.children?.length)
            ? (_openBlock(), _createElementBlock("ul", {
                key: 1,
                class: _normalizeClass(["sidebar__submenu", { 'open': item.menuOpen }])
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.children, (subitem) => {
                  return (_openBlock(), _createElementBlock("li", {
                    key: subitem?.to,
                    class: "sidebar__submenu-item"
                  }, [
                    _createVNode(_component_router_link, {
                      to: subitem.to
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(subitem.name), 1)
                      ]),
                      _: 2
                    }, 1032, ["to"])
                  ]))
                }), 128))
              ], 2))
            : _createCommentVNode("", true)
        ]))
      }), 128))
    ])
  ]))
}